module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result-courses"
  }, [_c('Header', [_vm._v("Результаты обучения")]), (_vm.dataItems && _vm.dataItems.length > 0) ? _vm._l((_vm.dataItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "result-courses_item ui_shadow"
    }, [_c('div', {
      staticClass: "image-box"
    }, [_c('img', {
      staticClass: "image-box_picture",
      attrs: {
        "src": require(("" + _vm.blankImage))
      }
    })]), _c('div', {
      staticClass: "info-box"
    }, [_c('InfoBlock', {
      attrs: {
        "item": item
      }
    })], 1)])
  }) : [_c('Warning', {
    attrs: {
      "isHeader": false
    }
  }, [_c('p', [_vm._v("У вас пока нет результатов обучения.")])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f261ba84","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/resultCourses/ResultCourses.vue
// module id = 5d0f4d4c472cc7c33aa3
// module chunks = 23